<template>
    <div class="symbol symbol-40 symbol-light-primary flex-shrink-0">
        <span class="symbol-label font-size-h6 font-weight-bold">{{ initials }}</span>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
    },

    computed: {
        initials() {
            let parts = this.name.split(' ');
            let initials = '';
            for (let part of parts) initials += part.substring(0, 1).toUpperCase();

            return initials.substring(0, 3);
        },
    },
}
</script>
